import {Component, ViewChild, AfterViewInit} from "@angular/core";
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-validation-text-box-renderer',
    template: `<irb-validation-text-box #validationTextBox 
                                        [value]="params.value"
                                        (applyChange)="onChange($event)"
                                        [regExp]="regExp"
                                        [invalidMessage]="invalidMessage"
                                        [placeholder]="placeholder"                                        
                                        [min]="min"
                                        [max]="max"
                                        width="100%"
                                        [disabled]="disabled"
                                        [autofocus]="autofocus"
                                        [prefix]="prefix"
                                        [suffix]="suffix"
                                        [minConstraint]="minConstraint"
                                        [maxConstraint]="maxConstraint"
                                        [invalidMinConstraintMessage]="invalidMinConstraintMessage"
                                        [invalidMaxConstraintMessage]="invalidMaxConstraintMessage"
                                        [allowNegativeValues]="allowNegativeValues"
                                        ></irb-validation-text-box>`
})
export class ValidationTextBoxRendererComponent implements ICellRendererAngularComp, AfterViewInit {
    params: any;
    originalValue: any;
    regExp: string;
    invalidMessage: string;
    placeholder: string;
    min: number;
    max: number;
    disabled: boolean;
    autofocus: boolean;
    prefix: string;
    suffix: string;
    minConstraint: string;
    maxConstraint: string;
    invalidMinConstraintMessage: string;
    invalidMaxConstraintMessage: string;
    allowNegativeValues: boolean;

    @ViewChild('validationTextBox') validationTextBox: any;

    agInit(params: any): void {
        this.params = params;
        this.originalValue = this.params.value;
        this.regExp = (this.params.regExp) ? this.params.regExp : null;
        this.invalidMessage = this.params.invalidMessage || "Invalid input";
        this.min = (this.params.min === 0) ? 0 : this.params.min || null;
        this.max = (this.params.max === 0) ? 0 : this.params.max || null;
        this.disabled = this.params.disabled || false;        
        this.autofocus = this.params.autofocus || false;
        this.prefix = this.params.prefix || null;
        this.suffix = this.params.suffix || null;
        this.minConstraint = this.params.minConstraint || null;
        this.maxConstraint = this.params.maxConstraint || null;
        this.invalidMinConstraintMessage = this.params.invalidMinConstraintMessage || null;
        this.invalidMaxConstraintMessage = this.params.invalidMaxConstraintMessage || null;
        this.allowNegativeValues = this.params.allowNegativeValues || null;
        this.placeholder = this.params.placeholder || "";
    }

    refresh(): boolean {
        return true;
    }

    onChange(v: any): void {
        if (this.params.onChange) {
            this.params.onChange(this.params, v);
        }
    }

    ngAfterViewInit() {
        if (this.autofocus && !this.disabled) {
            setTimeout(() => {
                if (this.params) {
                    const rowIndex = this.params.rowIndex || this.params.node.rowIndex;
                    this.params.api.setFocusedCell(rowIndex, this.params.column);
                    this.validationTextBox.inputField.nativeElement.focus();
                }
            }, 150);
        }
    }
}
